import { Pressable, View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'transparent',
      paddingTop: theme.paddingInsetTwopulse,
      paddingBottom: theme.paddingInsetTwopulse,
      paddingLeft: theme.paddingInsetTwopulse,
      paddingRight: theme.paddingInsetTwopulse,
    },
    variants: {},
  }
})

export const Container = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundColor: theme.colorActionTextNeutralDeactivated,
      width: theme.sizingMediumlarge,
      paddingTop: theme.paddingInsetHalfpulse,
      paddingBottom: theme.paddingInsetHalfpulse,
      paddingLeft: theme.paddingInsetHalfpulse,
      paddingRight: theme.paddingInsetHalfpulse,
      borderColor: theme.colorNone,
      borderWidth: theme.borderWidthNone,
      borderRadius: theme.borderRadiusMediumcontainer,
    },
    variants: {
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionTextNeutralPressed,
        },
      },
      hasValue: {
        true: {
          backgroundColor: theme.colorActionTextOnbrandDefault,
          justifyContent: 'flex-end',
        },
      },
      hasDisabled: {
        true: {
          backgroundColor: theme.colorTextNeutralDisabled,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          hasPressed: true,
          hasValue: true,
        },
        css: {
          backgroundColor: theme.colorActionTextOnbrandPressed,
        },
      },
      {
        variants: {
          hasInternalRefresh: true,
          hasValue: false,
        },
        css: {
          backgroundColor: theme.colorTextNeutralPlaceholder,
        },
      },
      {
        variants: {
          hasInternalRefresh: true,
          hasValue: true,
        },
        css: {
          backgroundColor: theme.colorActionTextOnbrandPressed,
        },
      },
    ],
  }
})
